import { Constraint } from "rily"
import { fetchData } from "./fetch"

export const fetchConstraints = async (): Promise<Constraint[]> => {
  return fetchData<Constraint[]>(`constraint`)
}
